<template>
  <div class="container">
    <!-- 顶部导航栏 -->
    <div class="top-bar" style="display: flex; justify-content: center; align-items: center;">
     <div class="top-bar-content" style="display: flex; justify-content: space-between; align-items: center; width: 90%;">
      <div class="logo" style="font-weight: bold;">
        <span style="color: #409EFF;">C</span>
        <span style="color: #409EFF;">o</span>
        <span style="color: #409EFF;">l</span>
        <span style="color: #409EFF;">o</span>
        <span style="color: #409EFF;">r</span>
        <span style="color: #409EFF;">Thinking</span>
      </div>
      
      <div class="nav-links">
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn icon="mdi-menu" variant="text" v-bind="props" style="color: #409EFF;" ></v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, i) in items"
              :key="i"
              :value="i"
              @click="goAbout(item.link)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>

            </v-list-item>  

          </v-list>

        </v-menu>
      </div>
     </div>
      
    </div>
    <!-- 主要内容区域 -->
    <div class="main-content">



      <v-card variant="elevated" hover class="card-container">
        <div class="app-card">
          <div class="app-info">
            <div class="app-logo">
              <img src="../assets/icon.png" alt="App Logo">
            </div>

            <div class="app-content">
              <div class="app-titles">
                <h2 class="main-title">{{ task.name }}</h2>
                <h2 class="sub-title" >{{ task.mark }}</h2>
              </div>
              <div class="platform-links">
                
                <v-btn rounded="xl" size="large" variant="tonal" color="purple" class="platform-btn" @click="goWeb(task.links.ios)">
                  <div class="btn-content">
                    <img src="../assets/294700_apple_icon.png" alt="apple" class="btn-icon">
                    <span>苹果客户端</span>
                  </div>
                </v-btn>
                <v-btn rounded="xl" size="large" variant="tonal" color="green" class="platform-btn" @click="download('task')">
                  <div class="btn-content">
                    <img src="../assets/4879894_android_app_device_mobile_screen_icon (1).png" alt="android" class="btn-icon">
                    <span>安卓客户端</span>
                  </div>
                </v-btn>
                <v-btn rounded="xl" size="large" variant="tonal" color="#03a9f4" class="platform-btn" @click="goWeb(task.links.web)"  >
                  <div class="btn-content">
                    <img src="../assets/326663_language_web_icon (2).png" alt="web" class="btn-icon">
                    <span>网页端</span>
                  </div>
                </v-btn>
              </div>
            </div>
           
          </div>
          
        </div>
      </v-card>

      <v-card variant="elevated" hover class="card-container">
        <div class="app-card">
          <div class="app-info">
            <div class="app-logo">
              <img src="../assets/pdfnoteblack.png" alt="App Logo">
            </div>

            <div class="app-content">
              <div class="app-titles">
                <h2 class="main-title">{{ pdfnote.name }}</h2>
                <h2 class="sub-title" >{{ pdfnote.mark }}</h2>
              </div>
              <div class="platform-links">
                <v-btn rounded="xl" size="large" variant="tonal" color="#03a9f4" class="platform-btn" @click="goWeb(pdfnote.links.web)"  >
                  <div class="btn-content">
                    <img src="../assets/326663_language_web_icon (2).png" alt="web" class="btn-icon">
                    <span>网页端</span>
                  </div>
                </v-btn>
                
                <v-btn rounded="xl" size="large" variant="tonal" color="purple" class="platform-btn" @click="goWeb(pdfnote.links.ios)" >
                  <div class="btn-content">
                    <img src="../assets/294700_apple_icon.png" alt="apple" class="btn-icon">
                    <span>苹果客户端</span>
                  </div>
                </v-btn>
                <v-btn rounded="xl" size="large" variant="tonal" color="green" class="platform-btn" @click="download('pdfnote')">
                  <div class="btn-content">
                    <img src="../assets/4879894_android_app_device_mobile_screen_icon (1).png" alt="android" class="btn-icon">
                    <span>安卓客户端</span>
                  </div>
                </v-btn>
                <DesktopDownloadButton />
                
              </div>
            </div>
           
          </div>
          
        </div>
      </v-card>

      <!--星终端-->
      <v-card variant="elevated" hover class="card-container">
        <div class="app-card">
          <div class="app-info">
            <div class="app-logo">
              <img src="../assets/shell.png" alt="App Logo">
            </div>

            <div class="app-content">
              <div class="app-titles">
                <h2 class="main-title">{{ shell.name }}</h2>
                <h2 class="sub-title" >{{ shell.mark }}</h2>
              </div>
              <div class="platform-links">

                <v-btn rounded="xl" size="large" variant="tonal" color="purple" class="platform-btn" disabled>
                  <div class="btn-content">
                    <img src="../assets/294700_apple_icon.png" alt="apple" class="btn-icon">
                    <span>苹果客户端</span>
                  </div>
                </v-btn>
                <v-btn rounded="xl" size="large" variant="tonal" color="green" class="platform-btn" disabled>
                  <div class="btn-content">
                    <img src="../assets/4879894_android_app_device_mobile_screen_icon (1).png" alt="android" class="btn-icon" >
                    <span>安卓客户端</span>
                  </div>
                </v-btn>

              </div>
            </div>

          </div>

        </div>
      </v-card>

      <v-card variant="elevated" hover class="card-container">
        <div class="app-card">
          <div class="app-info">
            <div class="app-logo">
              <img src="../assets/idea.png" alt="App Logo">
            </div>

            <div class="app-content">
              <div class="app-titles">
                <h2 class="main-title">{{ more.name }}</h2>
                <h2 class="sub-title" >{{ more.mark }}</h2>
              </div>
              
            </div>
           
          </div>
          
        </div>
      </v-card>
      
    </div>

    <!-- 页脚 -->
    <div class="footer" style="align-items: center; justify-content: center;">
      <a href="https://beian.miit.gov.cn/?f" target="_blank">沪ICP备2025122789号-1</a>
      <div style="justify-content: center; display: flex;">
        <img src="../assets/police.png"  class="btn-icon">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31010602008824" rel="noreferrer" target="_blank">沪公网安备31010602008824号</a>
      </div>  
    </div>
  </div>
</template>

<script setup>
import { mdiDotsVertical } from '@mdi/js'
import { useRouter } from 'vue-router'
import DesktopDownloadButton from './DesktopDownloadButton.vue'

const router = useRouter()
const menuIcon = mdiDotsVertical
const items = [
  { title: '关于我们', link: '/about' },
  { title: '联系我们', link: '/contact' },
  { title: '任务百分比隐私政策', link: '/document/task/privacy' },
  { title: '任务百分比使用条款', link: '/document/task/agreement' },
  { title: '彩思笔记隐私政策', link: '/document/pdfnote/privacy' },
  { title: '彩思笔记使用条款', link: '/document/pdfnote/agreement' },
  { title: 'XingShell隐私政策', link: '/document/xingshell/privacy' },
  { title: 'XingShell使用条款', link: '/document/xingshell/agreement' }
]

const goAbout = (link) => {
  router.push(link)
}

const goWeb = (link) => {
  window.location.href = link.trim()
}

const download = (target) => {
  const link = document.createElement('a');
  if (target === 'pdfnote') {
    link.href = 'https://www.colorthinking.com/files/pdfnote.apk';
    link.download = '彩思笔记.apk';
  } else {
    link.href = 'https://www.colorthinking.com/files/task.apk';
    link.download = '任务百分比.apk';
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const task = {
  id: 1,
  name: "任务百分比",
  mark:"任务百分比可在不同系统设备无缝使用,以百分比直观展示任务进度,云端同步助你高效管理任务",
  links: {
    web: 'https://www.colorthinking.com/task ',
    ios: 'https://apps.apple.com/cn/app/%E4%BB%BB%E5%8A%A1%E7%99%BE%E5%88%86%E6%AF%94/id6746470843',
    android: '#'
  }
}

const pdfnote = {
  id: 2,
  name: "彩思笔记",
  mark:"彩思笔记是一款跨平台的PDF笔记应用,实时增量同步用户的标注笔记,帮助用户高效管理PDF和笔记",
  links: {
    web: 'https://www.colorthinking.com/pdfnote ',
    ios: 'https://apps.apple.com/app/6756973642',
    android: '#'
  }
}

const shell = {
  id: 3,
  name: "XingShell",
  mark:"XingShell是一款易用的远程Shell应用,通过SSH和Sftp帮助用户高效管理远程服务器",
  links: {
    web: '#',
    ios: '#',
    android: '#'
  }
}

const more = {
  id: 1,
  name: "敬请期待更多",
  mark:"ColorThinking",
  links: {
    web: '#',
    ios: '#',
    android: '#'
  }
}

</script>

<style scoped>
/* 引入自定义字体 */
@font-face {
  font-family: 'YourFontName';
  src: url('../assets/fonts/Inter-Regular.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'YourFontName';
  src: url('../assets/fonts/Inter-Bold.woff2') format('woff2');
  font-weight: bold;
  font-style: normal;
}

/* 全局字体设置 */
:root {
  font-family: 'YourFontName', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f0f0f0;
  font-family: inherit;
}

/* 顶部导航栏样式 */
.top-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;

  padding-left: 2rem;
  padding-right: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo {
  font-size: clamp(1rem, 4vw, 2rem);
  
  color: #2c3e50;
  letter-spacing: 1px;
  font-family: inherit;
}

.nav-links {
  display: flex;
  gap: 2rem;
}

.nav-link {
  color: #666;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #3498db;
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  gap: 2rem;
  margin-top: 80px; /* 为固定导航栏留出空间 */
}

.card-container {
  width: 60%;
  min-height: 260px;
  background: white;
  border-radius: 50px;
  padding: 25px;
}

/* 应用卡片样式 */
.app-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}

.app-info {
  display: flex;
  align-items: center;
  gap: 2rem;
  height: 100%;
}

.app-logo {
  width: 210px;
  height: 210px;
  min-width: 210px;
  min-height: 210px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.app-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 40px;
}

.app-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  gap: 1rem;
}

.app-titles {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.main-title {
  font-size: 3rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.5px;
}

.sub-title {
  font-size: 1.5rem;
  font-weight: 100;
  color: #929292;
  margin: 0;
  letter-spacing: 0.5px;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  max-width: 100%;
  line-height: 1.4;
}

.platform-links {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.platform-btn {
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform-btn :deep(.v-btn__content) {
  display: flex;
  align-items: center;
  gap: 8px;
}

.platform-link:hover {
  opacity: 0.9;
}



/* 页脚样式 */
.footer {
  text-align: center;
  padding: 1rem;
}

.footer a {
  color: #666;
  text-decoration: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .top-bar {
    padding: 0.5rem 1rem;
  }

  .main-content {
    margin-top: 120px; /* 在移动端增加更多空间 */
    padding: 1rem;
    gap: 1rem;
  }

  .nav-links {
    flex-direction: column;
    gap: 1rem;
  }

  .card-container {
    width: 90%;
  }

  .app-card {
    flex-direction: column;
    text-align: center;
  }

  .app-info {
    flex-direction: column;
  }

  .platform-links {
    flex-direction: column;
    width: 100%;
  }
  
  .platform-btn {
    width: 100%;
  }

  .app-content {
    align-items: center;
    text-align: center;
  }
}
</style>
